import React from "react";
import { useObserver } from "mobx-react";
import locale from "@bonliva-crm/locale";
import { FormTab } from "@components/forms/common/FormTab";
import FormSection from "@components/forms/common/FormSection";
import { PersonalInfo } from "../sections/PersonalInfo";
import { AddressInfo } from "../sections/AddressInfo";
import { ContactsInfo } from "../sections/ContactsInfo";
import ConsultantFormSection from "../components/Common/ConsultantFormSection";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { GDPRInfo } from "@consultants/ConsultantEditor/sections/GDPRInfo";

export function PersonalTab() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();

  return useObserver(() => (
    <FormTab horizontal>
      <ConsultantFormSection
        title={locale["Personal information"]}
        hasValidated={!editorStore.consultantCVManager.hasChangesInPersonalInfo}
        validate={(e, c) => {
          if (c) {
            editorStore.consultantCVManager.approveKeyTemplate("personal");
          }
        }}
      >
        <PersonalInfo />
      </ConsultantFormSection>

      <FormSection fitted>
        <ConsultantFormSection
          title={locale["Address details"]}
          hasValidated={!editorStore.consultantCVManager.hasChangesInAddressInfo}
          validate={(e, c) => {
            if (c) {
              editorStore.consultantCVManager.approveKeyTemplate("address");
            }
          }}
          fullWidth
        >
          <AddressInfo />
        </ConsultantFormSection>

        <ConsultantFormSection
          title={locale["Contact details"]}
          hasValidated={!editorStore.consultantCVManager.hasChangesInContactInfo}
          validate={(e, c) => {
            if (c) {
              editorStore.consultantCVManager.approveKeyTemplate("contacts");
            }
          }}
          fullWidth
          style={{ marginTop: 16 }}
        >
          <ContactsInfo />
        </ConsultantFormSection>

        {editorStore.isNew && (
          <ConsultantFormSection
            title={locale.GDPR}
            fullWidth
            style={{ marginTop: 16 }}
          >
            <GDPRInfo />
          </ConsultantFormSection>
        )}
      </FormSection>
    </FormTab>
  ));
}
